import { render, staticRenderFns } from "./addCommunity.vue?vue&type=template&id=0da8d3ec&scoped=true&"
import script from "./addCommunity.vue?vue&type=script&lang=js&"
export * from "./addCommunity.vue?vue&type=script&lang=js&"
import style0 from "./addCommunity.vue?vue&type=style&index=0&id=0da8d3ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da8d3ec",
  null
  
)

export default component.exports